import * as React from 'react'

import { action, makeObservable, observable } from 'mobx'
import { inject, observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import TraceIdDisplay from '~/client/src/shared/components/TraceIdDisplay'
import { REPORT_ERROR } from '~/client/src/shared/stores/EventStore/eventConstants'
import EventsStore from '~/client/src/shared/stores/EventStore/Events.store'
import InitialState from '~/client/src/shared/stores/InitialState'

interface IProps {
  eventsStore?: EventsStore
  state?: InitialState
}

@inject('eventsStore', 'state')
@observer
export default class ErrorBoundary extends React.Component<IProps> {
  @observable private hasError: boolean = false

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  @action
  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.hasError = true
    this.props.eventsStore.dispatch(
      REPORT_ERROR,
      info.componentStack,
      error,
      'error',
    )
  }

  @action
  public UNSAFE_componentWillReceiveProps() {
    this.hasError = false
  }

  public render() {
    if (this.hasError) {
      return this.renderErrorMessage()
    }

    return this.props.children
  }

  private renderErrorMessage() {
    const traceId = this.props.state?.lastTraceId

    return (
      <div>
        <div className="text large center">Something went wrong.</div>
        {traceId && (
          <div className="mt20" style={{ textAlign: 'center' }}>
            <TraceIdDisplay traceId={traceId} />
          </div>
        )}
        <div className="row x-center mt30">
          <Button
            className="no-grow"
            style={{ flexBasis: 100 }}
            onClick={this.reloadPage}
          >
            Reload
          </Button>
        </div>
      </div>
    )
  }

  private reloadPage() {
    const { location } = window
    location.pathname = ''
  }
}

export function withErrorBoundary<T extends object>(
  Component: React.ComponentType<T>,
) {
  return (props: T) => (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  )
}
